module.exports = {"TXTCLI_Search":{"id":"TXTCLI_Search","defaultMessage":"Søg","flags":["TRACK"],"track":"Search"}}